import script from "./AccountSettingSendView.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountSettingSendView.vue?vue&type=script&setup=true&lang=js"

import "./AccountSettingSendView.vue?vue&type=style&index=0&id=5897a828&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5897a828"]])

export default __exports__